
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.074 3c-.398 0-.795.128-1.131.382a10.418 10.418 0 01-5.429 2.044.946.946 0 00-.834.933v5.131c0 3.55 4.299 6.195 6.345 7.253.33.171.69.257 1.05.257V3z","fill":"url(#paint0_linear_19681_40122)"}}),_c('path',{attrs:{"d":"M11.074 19c.362 0 .724-.086 1.056-.258 2.047-1.06 6.341-3.7 6.341-7.252V6.355a.942.942 0 00-.832-.929 10.418 10.418 0 01-5.43-2.044A1.872 1.872 0 0011.073 3v16z","fill":"url(#paint1_linear_19681_40122)"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M3.68 6.36v5.13c0 3.55 4.299 6.195 6.345 7.253a2.278 2.278 0 002.104-.001c2.048-1.06 6.342-3.7 6.342-7.252V6.355a.942.942 0 00-.832-.929 10.418 10.418 0 01-5.43-2.044 1.87 1.87 0 00-2.266 0 10.418 10.418 0 01-5.429 2.044.946.946 0 00-.834.933z","stroke":"#747474","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_19681_40122","x1":"4.395","y1":"10.6","x2":"10.681","y2":"10.6","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F9B621"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FCBD32"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_19681_40122","x1":"17.36","y1":"11","x2":"11.074","y2":"11","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#299FEA"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#6EB7E6"}})])])])
          )
        }
      }
    